// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uploadImg {
    display: none;
    /* הסתר את כפתור הקובץ */
}

.uploadLabel {
    display: inline-block;
    padding: 10px 20px;
    background-color: #bfd9ff;
    color: white;
    font-size: 16px;
    border: none;
    cursor: pointer;
    border-radius: 5px;
    transition: background-color 0.3s;
    margin: 5px;
}

.uploadLabel:hover {
    background-color: #0b37ba;
}

.uploadLabel:active {
    background-color: #456aff;
}


.uploadBtn {
    background-color: red;
    padding: 7px;
    border-radius: 5px;
    margin: 5px;
    color: white;


}
.ImgManagerTitle{
    background-color: white;
    padding: 40px;
    font-size: 20pt;
    font-weight: 700;
    border-radius: 20px;
    margin: 100px 20px 20px 20px;
    width: 80%;
}

.ImgManagerContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.uploadImgContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/MonitorPage/monitorManager/UploadImageCloudinary.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,iCAAiC;IACjC,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;;;AAGhB;AACA;IACI,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,4BAA4B;IAC5B,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB","sourcesContent":[".uploadImg {\r\n    display: none;\r\n    /* הסתר את כפתור הקובץ */\r\n}\r\n\r\n.uploadLabel {\r\n    display: inline-block;\r\n    padding: 10px 20px;\r\n    background-color: #bfd9ff;\r\n    color: white;\r\n    font-size: 16px;\r\n    border: none;\r\n    cursor: pointer;\r\n    border-radius: 5px;\r\n    transition: background-color 0.3s;\r\n    margin: 5px;\r\n}\r\n\r\n.uploadLabel:hover {\r\n    background-color: #0b37ba;\r\n}\r\n\r\n.uploadLabel:active {\r\n    background-color: #456aff;\r\n}\r\n\r\n\r\n.uploadBtn {\r\n    background-color: red;\r\n    padding: 7px;\r\n    border-radius: 5px;\r\n    margin: 5px;\r\n    color: white;\r\n\r\n\r\n}\r\n.ImgManagerTitle{\r\n    background-color: white;\r\n    padding: 40px;\r\n    font-size: 20pt;\r\n    font-weight: 700;\r\n    border-radius: 20px;\r\n    margin: 100px 20px 20px 20px;\r\n    width: 80%;\r\n}\r\n\r\n.ImgManagerContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.uploadImgContainer {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-top: 20px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
